var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_c('code-box',{attrs:{"code":_vm.code,"markdown":_vm.md}},[_c('demo-comp',{attrs:{"slot":"demo"},slot:"demo"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }